import { useLoader } from "@core/hooks/useLoader";
import { loader } from "@ecom/categories.route";

export const useCategoryTree = () => {
  const { data, loading } = useLoader<typeof loader>("/categories");
  return { categories: data?.tree, loading };
};
